import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComprasRoutingModule } from './compras-routing.module';
import { ProveedorAddComponent } from './proveedor-add/proveedor-add.component';
import { ProveedorEditComponent } from './proveedor-edit/proveedor-edit.component';
import { ProveedorListComponent } from './proveedor-list/proveedor-list.component';
import { CompraAddComponent } from './compra-add/compra-add.component';
import { RetencionesCompraListComponent } from './retenciones-compra-list/retenciones-compra-list.component';
import { RetencionesCompraAddComponent } from './retenciones-compra-add/retenciones-compra-add.component';
import { PagoListComponent } from './pago-list/pago-list.component';
import { PagoAddComponent } from './pago-add/pago-add.component';
import { PagoGrupoComponent } from './pago-grupo/pago-grupo.component';
import { GastoListComponent } from './gasto-list/gasto-list.component';
import { GastoAddComponent } from './gasto-add/gasto-add.component';
import { NotaCreditoCompraListComponent } from './nota-credito-compra-list/nota-credito-compra-list.component';
import { NotaCreditoCompraAddComponent } from './nota-credito-compra-add/nota-credito-compra-add.component';
import { CompraListComponent } from './compra-list/compra-list.component';
import { LoadingModule } from 'ngx-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';
import { RlTagInputModule } from 'angular2-tag-input';
import { ControlsModule } from '../../controls/controls.module';
import { ModalsModule } from '../modals/modals.module';
import { LiquidacionCompraAddComponent } from './liquidacion-compra-add/liquidacion-compra-add.component';
import { LiquidacionCompraListComponent } from './liquidacion-compra-list/liquidacion-compra-list.component';
import { BsDropdownModule } from 'ngx-bootstrap';
import { OrdenCompraAddComponent } from './orden-compra-add/orden-compra-add.component';
import { OrdenCompraListComponent } from './orden-compra-list/orden-compra-list.component';
import { CustomFormModule } from '../../forms/custom-form.module';
import { TextMaskModule } from 'angular2-text-mask';
@NgModule({
  imports: [
    CommonModule,
    ComprasRoutingModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    NguiDatetimePickerModule,
    RlTagInputModule,
    ControlsModule,
    ModalsModule,
    BsDropdownModule.forRoot(),
    CustomFormModule,
    TextMaskModule,
  ],
  declarations: [
    ProveedorAddComponent,
    ProveedorEditComponent,
    ProveedorListComponent,
    CompraListComponent,
    CompraAddComponent,
    RetencionesCompraListComponent,
    RetencionesCompraAddComponent,
    PagoListComponent,
    PagoAddComponent,
    PagoGrupoComponent,
    GastoListComponent,
    GastoAddComponent,
    NotaCreditoCompraListComponent,
    NotaCreditoCompraAddComponent,
    LiquidacionCompraAddComponent,
    LiquidacionCompraListComponent,
    OrdenCompraAddComponent,
    OrdenCompraListComponent,
  ],
  exports: [
    RetencionesCompraAddComponent,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
})
export class ComprasModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/compras.module.ts